import { PDFJS_DIST_FALLBACK_VERSION } from "./pdfjsDistFallbackVersion";

export const getPdfJsWorkerSrc = (pdfjsLib) => {
  const version = pdfjsLib?.version || PDFJS_DIST_FALLBACK_VERSION;
  return `https://cdn.jsdelivr.net/npm/pdfjs-dist@${version}/legacy/build/pdf.worker.min.mjs`;
};

export const configurePdfJsWorker = (pdfjsLib) => {
  if (!pdfjsLib?.GlobalWorkerOptions) return;
  const workerSrc = getPdfJsWorkerSrc(pdfjsLib);
  if (pdfjsLib.GlobalWorkerOptions.workerSrc !== workerSrc) {
    pdfjsLib.GlobalWorkerOptions.workerSrc = workerSrc;
  }
};
